import { SvgIcon } from '@mui/material';

export default function Icon(props = {}) {
  return <SvgIcon viewBox="0 0 40 40" {...props} />;
}
